import React from 'react';
// @ts-ignore
import userAgent from 'lib/currentUserAgent';
import CoachingConstants from 'coaching/CoachingConstants';
import Columns2 from 'components/Columns2';
import Container from 'components/Container';
import Link from 'components/Link';
import Row from 'components/Row';
import Text from 'components/Text';
import CoachingHeading from 'coaching/components/CoachingHeading';

const resources = [
  {
    resourceName: 'View all Tutoring Docs',
    description:
      "View all of your tutoring docs in one place (including your tutoring handbook, session summary guides, curriculum resources, and onboarding questionnaire guide). The password you'll need to access was sent via the Coach Newsletter on 8/23 and Remind Message Announcement on 8/30. If you are a new coach, it was included in your onboarding docs. Send a request above if you can't find it.",
    resourceUrl: CoachingConstants.TUTOR_DOCS,
    asHref: true,
  },
  {
    resourceName: 'Does your student/parent have a question?',
    description:
      'Feel free to direct them to the student help center! It walks them through a variety of situations, including common scheduling questions, how to best contact us, and updating payment methods.',
    resourceUrl: CoachingConstants.TUTOR_QUESTIONS_LINK,
    asHref: true,
  },
];

export default function CoachingCoachHelpAdditionalResourcesSection() {
  const isDesktop = userAgent.isDesktop();
  const renderedResources = resources.map(props => {
    if (isDesktop) {
      return <ResourceColumn key={props.resourceName} {...props} />;
    }

    return (
      <Row size="xlarge">
        <ResourceColumn key={props.resourceName} {...props} isDesktop={false} />
      </Row>
    );
  });

  return (
    <Container>
      <CoachingHeading textSize="xlarge" size="xxxlarge" centerText>
        Additional Resources
      </CoachingHeading>
      {isDesktop ? <Columns2 divider>{renderedResources}</Columns2> : renderedResources}
    </Container>
  );
}

type ResourceColumnProps = {
  resourceName: string;
  description: string;
  resourceUrl: string;
  asHref?: boolean;
  isDesktop?: boolean;
};

function ResourceColumn(props: ResourceColumnProps) {
  const { resourceName, description, resourceUrl, asHref, isDesktop = true } = props;
  const linkProps = {
    to: asHref ? undefined : resourceUrl,
    href: asHref ? resourceUrl : undefined,
    target: asHref ? '_blank' : undefined,
  };

  return (
    <React.Fragment>
      <Row size="small">
        <Text size="xlarge" weight="semibold" align="center">
          {resourceName}
        </Text>
      </Row>
      <Row size={isDesktop ? 'large' : 'small'}>
        <Text color="graphite" size="medium" align="center">
          {description}
        </Text>
      </Row>
      <Text size="medium" weight="semibold" align="center">
        <Link color="koolaid" {...linkProps}>
          View resource
        </Link>
      </Text>
    </React.Fragment>
  );
}
